// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__1rCaJ","content":"navbar_content__5FKQO","social":"navbar_social__3ffb3","label":"navbar_label__LIL5K"};